import { render, staticRenderFns } from "./pop_manager.vue?vue&type=template&id=5d8129a9&scoped=true&"
import script from "./pop_manager.vue?vue&type=script&lang=js&"
export * from "./pop_manager.vue?vue&type=script&lang=js&"
import style0 from "./pop_manager.vue?vue&type=style&index=0&id=5d8129a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8129a9",
  null
  
)

export default component.exports